<template>

    <div class="cmp-licencing-licence-sidewindow-licence_advance_setup dt-page">

        <Dropdown2

          id="currency_id"
          :label="$t('currency')"
          :placeholder="'Select ' + $t('currency')"
          style="color: var(--text-primary)"
          :disabled="false"
          :options="currencyIdTV"
          :selected="currencyIdTV.find(e=>e.value==selectedLicenceDetails.licence.currency_id)||currencyIdTV.find(e=>e.value==selectedLicenceDetails.licence.l_currency_id)"
          v-on:selectedChange="e => onDropdownChange('currency_id', e)"
        />
        <DatePicker2
            :disabled="false"
            id="date_start"
            :label="$t('start')"
            :value="dateValue"
            @input="onDateUpdate"
        />
 
        <TextField2
          
            id="term_years"
            class="m1"
            :placeholder="$t('contract_term')"
            :label="$t('contract_term')"
            :value="selectedLicenceDetails.licence.term_years"
           
            @blur=" e => onTextFieldValueChange(e) "
        />

        <TextField2
          
            id="sell_off_months"
            class="m1"
            :placeholder="$t('sell_off_months')"
            :label="$t('sell_off_months')"
            :value="selectedLicenceDetails.licence.term_month"
           
            @blur=" e => onTextFieldValueChange(e) "
        />

        <Dropdown2

          id="accounting_period"
          :label="$t('accounting_period')"
          :placeholder="'Select ' + $t('accounting_period')"
          :disabled="false"
          style="color: var(--text-primary);"
          :options="accountingPeriodsTV"
          :selected="accountingPeriodsTV.find(e=>e.value==selectedLicenceDetails.licence.accounting_period)"
          v-on:selectedChange="e => onDropdownChange('accounting_period', e)"
        />
        
        <TextField2
          
            id="due_days"
            class="m1"
            :placeholder="$t('due_days')"
            :label="$t('due_days')"
            :value="selectedLicenceDetails.licence.due_days"
            :bb="'0px'"
            @blur=" e => onTextFieldValueChange(e) "
        />


   
    </div> 
</template>
<script>

import {
  createTV,
  tv,
} from "../../../../models/text-value.model";



export default {
  props: {

    selectedLicenceDetails:{
      type:Object
    },
    releaseTypes:{
      type:Array
    }

  },

  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true
      },

      currency_id:'',
      date_start:'',
      term_years:'',
      term_month:'',
      accounting_period:'',
    };
  },
  methods:{
    onDateUpdate: function ({ name, value }) {
      // console.log(name, value);
      this.$emit("changed", { name, value });
    },
    onTextFieldValueChange:function (e ) {
      const payload={ 
                      name:e.name ,
                      value:e.value,
                    
                    }
      this.$emit('changed',payload)
      console.log("WERERTYUPOIUN",payload)
    },
    onDropdownChange:function(name,e){
      const payload={
                      name:name ,
                      value:e.value,
                    }
      this.$emit('changed',payload)
      console.log("WERERTYUPOIUN",payload)
    },


  },
  computed:{
    accountingPeriodsTV :function(){
  
      return[
          {text:"flat fee",value:"flat_fee"},
          {text:"bi annually",value:"bi_annually"},
          {text:"monthly",value:"monthly"},
          {text:"quarterly",value:"quarterly"},
        ]
    },
    currencyIdTV:function(){
        return createTV(this.selectedLicenceDetails.currencies,"currency_iso","currency_id");
    },

    dateValue:function(){
      if(this.selectedLicenceDetails?.licence?.date_start && this.selectedLicenceDetails?.licence?.date_start!='0000-00-00'){
        return this.selectedLicenceDetails?.licence?.date_start;
      }else{
        return this.selectedLicenceDetails?.licence?.l_date_start
      }
    }
  }

}
</script>
<style lang="scss">
.cmp-licencing-licence-sidewindow-licence_advance_setup{
  .dropdown--main{
    .dropdown--main__text{
    color: var(--text-primary);
  }
  }

  .flex-container {
    display:flex;
    padding: 10px;
    .flex-item{
      flex:0.25;
      padding:10px
    }
  }

}
</style>
